'use client';

import { Analytics } from '@vercel/analytics/next';
import { SpeedInsights } from '@vercel/speed-insights/next';
import type { ReactElement } from 'react';

import {
  speedInsightsBeforeSend,
  vercelAnalyticsBeforeSend,
} from './vercel-telemetry-redaction';

/** Vercel Analytics and Speed Insights with share link tokens redacted (r7 #1); the layout is a server component. */
export function VercelTelemetry(): ReactElement {
  return (
    <>
      <Analytics beforeSend={vercelAnalyticsBeforeSend} />
      <SpeedInsights beforeSend={speedInsightsBeforeSend} />
    </>
  );
}
